module.exports = __webpack_public_path__ + "static/media/md-paper-plane.d4ae298a.svg";